<div class="appo-appointment-proof">
  <ng-container *ngIf="isButton; else sendProofDiv">
    <button class="si-button_main w-100" (click)="onClickProof()">
      {{(sendByEmail ? 'SI_SEND_PROOF_EMAIL': 'SI_DOWNLOAD_PROOF') | translate}}
    </button>
  </ng-container>
  <ng-template #sendProofDiv>
    <div class="d-flex align-items-center appo-appointment-proof_route" (click)="onClickProof()">
      <i class="mr-1" [ngClass]="sendByEmail ? 'icosun-email' : 'icosun-download'"></i>
      <span>{{(sendByEmail ? 'SI_SEND_PROOF_EMAIL': 'SI_DOWNLOAD_PROOF') | translate}}</span>
    </div>
  </ng-template>
</div>
